import moment from "moment";

import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientRecallsListItem } from "@/Patient/Models/History/PatientRecallsListItem";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientHistoryRecallsHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalPatientOperations.History.Recall_LoadPatientRecall, this.LoadPatientRecall);
        this.RegisterOperation(LocalPatientOperations.History.Recall_ShowSelectedRecall, this.SetSelectedRecall);
        this.RegisterOperation(LocalPatientOperations.History.Recall_SearchText, this.SearchText);
        this.RegisterOperation(LocalPatientOperations.History.Recall_CriteriaClick, this.CriteriaClick);
        this.RegisterOperation(LocalPatientOperations.History.Recall_FromDateChanged, this.FromDateChanged);
        this.RegisterOperation(LocalPatientOperations.History.Recall_ToDateChanged, this.ToDateChanged);
        this.RegisterOperation(LocalPatientOperations.History.Recall_MarkRecallAsCompleted, this.MarkRecallAsCompleted);
        this.RegisterOperation(LocalPatientOperations.History.Recall_AddNewEntry, this.OpenNewEntryPopup);
        this.RegisterOperation(LocalPatientOperations.History.Recall_CancelNewEntry, this.CloseNewEntryPopup);
        this.RegisterOperation(LocalPatientOperations.History.Recall_LoadSelectedRecall, this.loadSelectedRecall);
        this.RegisterOperation(LocalPatientOperations.History.Recall_ShowOnlyNotCompleted, this.ToggleAppointmentDisplayMode);
    }

    private ToggleAppointmentDisplayMode(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];

        var showOnlyNotCompleted = recallModel.get("ShowOnlyNotCompleted");
        recallModel = recallModel.set("ShowOnlyNotCompleted", !showOnlyNotCompleted);
        store.PatientHistoryRecallsModels[request.PatientId];

        var expand = recallModel.get("IsCriteriaExpanded");

        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;

        if (expand) {
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), recallModel.get("DateFrom"), recallModel.get("DateTo"));
        }
        else {
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), null, null);
        }
    }

    public LoadPatientRecall(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];

        if (recallModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), recallModel.get("DateFrom"), recallModel.get("DateTo"));
        else
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), null, null);
    }

    private CloseNewEntryPopup(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];
        recallModel = recallModel.set("ShowNewEntryPopup", false);
        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;
    }

    private OpenNewEntryPopup(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];
        recallModel = recallModel.set("ShowNewEntryPopup", true);
        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;
    }

    private MarkRecallAsCompleted(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];

        var recallId = recallModel.get("SelectedRecallId");
        store.ActionsHistory.MarkSelectedRecallAsCompleted(recallId);

        if (recallModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), recallModel.get("DateFrom"), recallModel.get("DateTo"));
        else
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), null, null);
    }

    private FromDateChanged(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];
        recallModel = recallModel.set("DateFrom", request.Get<Date>("value"));
        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;
        store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), recallModel.get("DateFrom"), recallModel.get("DateTo"));
    }

    private ToDateChanged(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];
        recallModel = recallModel.set("DateTo", request.Get<Date>("value"));
        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;
        store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), recallModel.get("DateFrom"), recallModel.get("DateTo"));
    }

    public CriteriaClick(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];
        var open = recallModel.get("IsCriteriaExpanded");

        recallModel = recallModel.set("IsCriteriaExpanded", !open);

        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;

        if (recallModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), recallModel.get("DateFrom"), recallModel.get("DateTo"));
        else
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), null, null);
    }

    public SearchText(request: LocalEvent, store: PatientStore): void {
        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];
        var searchText = request.Get<string>("value");
        recallModel = recallModel.set("SearchText", searchText);
        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;

        if (recallModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), recallModel.get("DateFrom"), recallModel.get("DateTo"));
        else
            store.ActionsHistory.LoadPatientRecall(request.PatientId, recallModel.get("SearchText"), recallModel.get("ShowOnlyNotCompleted"), null, null);
    }

    public SetSelectedRecall(request: LocalEvent, store: PatientStore): void {
        var recall = request.Get<PatientRecallsListItem>("recall");

        var recallModel = store.PatientHistoryRecallsModels[request.PatientId];

        recallModel = recallModel.set("ShowDetails", true);
        recallModel = recallModel.set("SelectedRecallId", recall.Model.RecallId);
        recallModel = recallModel.set("IsCompleted", recall.Model.IsCompleted);
        recallModel = recallModel.set("Description", recall.Model.Type);
        recallModel = recallModel.set("Provider", recall.Model.To);
        recallModel = recallModel.set("Speciality", recall.Model.Specialization);
        recallModel = recallModel.set("DueDate", recall.Model.DueDate);
        recallModel = recallModel.set("CreatedBy", recall.Model.CreatedBy);
        recallModel = recallModel.set("Priority", recall.Model.Priority);
        recallModel = recallModel.set("Notes", recall.Model.Notes);

        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;

        store.ActionsHistory.LoadRecallCommunication(recall.Model.RecallId);
    }

    private loadSelectedRecall(request: LocalEvent, store: PatientStore): void {
        let type = request.Get<string>("type");
        let dueDate = moment(request.Get<Date>("dueDate")).format("YYYY/MM/DD");

        let recallModel = store.PatientHistoryRecallsModels[request.PatientId];
        let recallList = recallModel.get("RecallsList");
        let selectedRecallId = recallModel.get("SelectedRecallId");

        recallModel = recallModel
            .set("Description", type)
            .set("DueDate", dueDate)
            .set("ShowNewEntryPopup", false);

        if (recallList) {
            let convertedRecallList = recallList.toArray().mutate(x => {
                x.Model.DueDate = dueDate;
                x.Model.Type = type;
            }, z => z.Model.RecallId == selectedRecallId);
            recallModel = recallModel.set("RecallsList", convertedRecallList.toImmutable());
        }

        store.PatientHistoryRecallsModels[request.PatientId] = recallModel;
        store.ActionsHistory.LoadRecallCommunication(selectedRecallId);
    }
}

export { PatientHistoryRecallsHandler };
